import { resetHubFiltersVar } from "./hubFiltersVar"
import { resetJobFiltersStateVar } from "./jobs/jobFiltersStateVar"

const resetStateVars = () => {
  resetJobFiltersStateVar()
  resetHubFiltersVar()
}

export { resetStateVars }
